import React from "react";
import {
  PdfSlateBaseParentBlockNode,
  PdfSlateEndnote,
  PdfSlateImage,
  PdfSlateLink,
  PdfSlateTextNode,
  PdfTheme,
} from "../types";
import {
  CalloutBackground,
  CalloutBorder,
  SlateListBlock,
} from "../../../../types/slate";
import { View, StyleSheet } from "@surge-global-engineering/rpdf-renderer";
import BaseChildNode from "./BaseChildNode";
import { convertHexToRGBA } from "../../../../utils/hexToRgba";
import { ClearFloat } from "@surge-global-engineering/react-pdf-components";

interface CalloutBoxProps {
  index: number;
  nodeIndex: number;
  theme: PdfTheme;
  endNotes: PdfSlateEndnote[];
  showFirstSentenceFormatting: boolean;
  children: (
    | PdfSlateEndnote
    | PdfSlateTextNode
    | PdfSlateLink
    | PdfSlateBaseParentBlockNode
    | SlateListBlock
    | PdfSlateImage
  )[];
  parentType: string;
  background: CalloutBackground;
  border: CalloutBorder;
  endNotesOffset?: number;
}

export const CalloutBox: React.FC<CalloutBoxProps> = ({
  index,
  nodeIndex,
  theme,
  endNotes,
  children,
  parentType,
  background,
  border,
}: CalloutBoxProps) => {
  const fillColor = convertHexToRGBA(
    background.fillColor,
    background.fillOpacity
  );
  const borderColor = convertHexToRGBA(
    border.borderColor,
    border.borderOpacity
  );

  const styles = StyleSheet.create({
    container: {
      marginTop: "3pt",
      marginBottom: "3pt",
      backgroundColor: background.fill ? fillColor : "transparent",
      border: border.border
        ? `${border.borderWidth}pt ${border.borderStyle} ${borderColor}`
        : "none",
      borderRadius: border.border ? `${border.borderRadius}pt` : "0pt",
      padding: "5pt 8pt 8pt 8pt",
    },
  });

  return (
    <>
      <ClearFloat />  
      <View key={`calloutbox-${index}`} style={styles.container}>
        <BaseChildNode
          key={`calloutbox-${index}`}
          theme={theme}
          nodeIndex={nodeIndex}
          endNotes={endNotes}
          parentType={parentType}
          showFirstSentenceFormatting={false}
        >
          {children}
        </BaseChildNode>
        <ClearFloat />
      </View>
    </>
  );
};
